import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { D3LineGaugeChartComponent } from '@app/shared/components/d3-line-gauge-chart/d3-line-gauge-chart.component';
import { SharedModule } from '@app/shared/shared.module';
import { AddObjectTreeComponent } from './components/add-object-tree/add-object-tree.component';
import { BuildingEfficiencyDetailsComponent } from './components/building-efficiency-details/building-efficiency-details.component';
import { BuildingEfficiencyResultsComponent } from './components/building-efficiency-wizard/building-efficiency-results/building-efficiency-results.component';
import { BuildingEfficiencyWizardComponent } from './components/building-efficiency-wizard/building-efficiency-wizard.component';
import { ElectricityMeterSelectionComponent } from './components/building-efficiency-wizard/electricity-meter-selection/electricity-meter-selection.component';
import { HeatSelectionComponent } from './components/building-efficiency-wizard/heat-selection/heat-selection.component';
import { TimePeriodSelectionComponent } from './components/building-efficiency-wizard/time-period-selection/time-period-selection.component';
import { BuildingTypeFilterComponent } from './components/building-type-filter/building-type-filter.component';
import { EmptyBuildingsPopupComponent } from './components/empty-buildings-popup/empty-buildings-popup.component';
import { ModifyEfficiencyTresholdComponent } from './components/modify-efficiency-treshold/modify-efficiency-treshold.component';
import { EfficiencyAnalysisConfigDialogComponent } from './dialog/efficiency-analysis-config-dialog/efficiency-analysis-config-dialog.component';
import { ModifyReferenceValuesComponent } from './dialog/efficiency-analysis-config-dialog/modify-reference-values/modify-reference-values.component';
import { EfficiencyAnalysisComponent } from './efficiency-analysis.component';
import { EfficiencyAnalysisRoutingModule } from './efficiency-analysis-routing.module';

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, MatTreeModule, MatIconModule, MatButtonModule, MatCheckboxModule, EfficiencyAnalysisRoutingModule],
  declarations: [
    EfficiencyAnalysisComponent,
    BuildingEfficiencyDetailsComponent,
    AddObjectTreeComponent,
    BuildingTypeFilterComponent,
    ModifyEfficiencyTresholdComponent,
    EmptyBuildingsPopupComponent,
    ModifyReferenceValuesComponent,
    EfficiencyAnalysisConfigDialogComponent,
    BuildingEfficiencyWizardComponent,
    BuildingEfficiencyResultsComponent,
    ElectricityMeterSelectionComponent,
    HeatSelectionComponent,
    TimePeriodSelectionComponent,
    D3LineGaugeChartComponent,
  ],
  exports: [BuildingEfficiencyWizardComponent, D3LineGaugeChartComponent],
})
export class EfficiencyAnalysisModule {}
